import { TabPanel, TabView } from 'primereact'
import React, { useEffect, useState } from 'react'
import TomaInventarioMantenimiento from './Taps/TomaInventarioMantenimiento';
import InventarioMantenimiento from './Taps/InventarioMantenimiento'
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';

const InventarioMantenimientoScreen = () => {

  useEffect(() => {
    setTitlePage('Productos')
  }, [])

  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <div>
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Inventario">
          <InventarioMantenimiento />
        </TabPanel>
        <TabPanel header="Toma de Inventario">
          <TomaInventarioMantenimiento/>
        </TabPanel>
      </TabView>
    </div>
  )
}

export default InventarioMantenimientoScreen